import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=11070999&scoped=true"
import script from "./top-menu.vue?vue&type=script&lang=ts"
export * from "./top-menu.vue?vue&type=script&lang=ts"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=11070999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11070999",
  null
  
)

export default component.exports